<template>
	<MainLayout>
		<div class="container">
			<div class="box">
				<div>
					<!---------SIDEBAR FILTERS-------->
					<div
						class="floating-tab"
						>
						<b-button variant="success" size="md"  v-b-toggle.sidebar-filters >
							<md-icon icon="tune"></md-icon> Filtros
						</b-button>
					</div>
					<b-sidebar id="sidebar-filters" title="Filtros" shadow sidebar-class="sidebar-filters" right backdrop >
						<div class="px-3 py-2">
							<Filters
									id="realtime-index-filters"
									:filters.sync="filters"
									:openFiltersOpts="true"
									:freezFilter="false"
									@search="updateLists"
								/>
						</div>
						<template #footer="{ hide }">
							<div class="d-flex bg-dark text-light align-items-center px-3 py-2">
								<strong class="mr-auto"></strong>
								<b-button size="sm" @click="hide">Close</b-button>
							</div>
						</template>
					</b-sidebar>
					<!---------SIDEBAR FILTERS-------->
					<b-tabs content-class="mt-3" align="center">
						<b-tab title="Rides por Status" active>
							<b-form @submit.prevent="() => updateLists()">
								<b-row>
									<div class="col-md-3">
										<h4 class="inline-heading">Operacion en vivo</h4>
									</div>
								</b-row>
								<br>
								<Filters
									v-if="false"
									id="realtime-index-filters"
									:filters.sync="filters"
									:openFiltersOpts="false"
									:freezFilter="true"
									@search="updateLists"
								/>
							</b-form>

							<div class="pt-3">
								<b-tabs content-class="mt-3" v-model="tabActive">
									<!-- Tab principal con rides resumidas -->
									<b-tab title="Rides" active>
										<ResumeOperation ref="resumeOperation" :filters="filtersClean"/>
									</b-tab>
									<b-tab title="Estadisticas">

										<b-overlay :show="loadingPanels">
											<b-card-group deck>

												<b-card
													border-variant="primary"
													header="Conductores"
													header-bg-variant="primary"
													header-text-variant="white"
												>
													<b-row>
														<b-col cols="7">
															<span>Servicios asignados</span>
														</b-col>
														<b-col class="text-right">
															<b>{{panels.drivers.assigned.value}} / {{panels.drivers.assigned.percent}}%</b>
														</b-col>

													</b-row>
													<b-row>
														<b-col cols="7">
															<span>Servicios no asignados</span>
														</b-col>
														<b-col class="text-right">
															<b>{{panels.drivers.notAssigned.value}} / {{panels.drivers.notAssigned.percent}}%</b>
														</b-col>

													</b-row>

												</b-card>
												<b-card
													border-variant="primary"
													header="Driver App"
													header-bg-variant="primary"
													header-text-variant="white"
												>
													<b-row>
														<b-col cols="7">
															<span>Servicios finalizado con éxito</span>
														</b-col>
														<b-col class="text-right">
															<b>{{panels.driverAppUse.finished.value}} / {{panels.driverAppUse.finished.percent}}%</b>
														</b-col>

													</b-row>
													<b-row>
														<b-col cols="7">
															<span>Servicios no completados</span>
														</b-col>
														<b-col class="text-right">
															<b>{{panels.driverAppUse.notFinished.value}} / {{panels.driverAppUse.notFinished.percent}}%</b>
														</b-col>
													</b-row>
												</b-card>
												<b-card
													border-variant="primary"
													header="Tracking Status"
													header-bg-variant="primary"
													header-text-variant="white"
												>

													<div  v-for="item in trackingStatus" :key="item.value">
														<b-row class="mb-1">
															<b-col cols="7">
																<span>{{item.text}}</span>
															</b-col>
															<b-col class="text-right">
																<b>{{getDataTrackingStatus(item.value,'value')}} / {{getDataTrackingStatus(item.value,'percent')}}%</b>
															</b-col>
														</b-row>
													</div>

												</b-card>
											</b-card-group>
										</b-overlay>


									</b-tab>
								</b-tabs>
							</div>
						</b-tab>
						<b-tab title="Conductores GPS">
							<KeepAlive>
								<DriverLocationModule/>
							</KeepAlive>
						</b-tab>
					</b-tabs>
				</div>

			</div>
			<!-- Modal detalle reserva de servicio -->
			<FormReservation
				ref="single"
				:formTypeWork="formTypeWork"
				:model-id="modelId"
				v-model="showSingleModal"
			/>
			<vue-snotify></vue-snotify>
		</div>
	</MainLayout>
</template>
<script>
import MainLayout from "../layout/MainLayout.vue";
import FormReservation from "../reservation/formReservation/index.vue";
import Filters from "@/components/sections/reservations/Filters";
import Pusher from "../../../plugins/pusher.js";
import DriverLocationModule from "./DriversLocation.vue";
import moment from "moment";
import ResumeOperation from "./components/ResumeOperation.vue";
                                   
export default {
	components: { MainLayout, FormReservation, Filters , DriverLocationModule, ResumeOperation },
	data() {
		const now = moment().format("YYYY-MM-DD");
		let defaultFilters = {
			id: "",
			clientFullName: "",
			clientPhone: "",
			destination: [],
			salesChannel: [],
			supplier: [],
			airport: [],
			serviceType: [],
			pickupStartDate: now,
			pickupStartTime: "",
			pickupEndDate: now,
			pickupEndTime: "", 
			creationStartDate: "",
			creationEndDate: "",
			cancelationStartDate: "",
			cancelationEndDate: "",
			asignationStartDate: "",
			asignationEndDate: "",
			trip: 0,
			contactStatus: 0,
			revisedStatus: null,
			status: [{ value: "active", text: "Activo" }],
			statusCheckin: [],
			salesChannelReference: "",
			supplierReference: "",
			containsEmail: "",
			clientEdited: "",
			clientConfirmed: "",
			showAdvancedOptions: false,
			pickupDatetimeConfirmed: null,
			fromPointOfSale: null,
			supplierConfirmation: null,
			placesWithoutCoordinates: null,
			supplierPriceTotalEmpty: null,
			onlyWithAdditionalServices: false,
			oneway: false,
			zones:[],
			invalidSupplierServiceType:false,
			withSalesChannelPromo:false,
			withSupplierPromo: false, 
			serviceTypeCategory: [],
			withChat: false,
			tags:[],
			netPriceTotalStart:null,
			netPriceTotalEnd:null,
			supplierPriceTotalStart:null,
			supplierPriceTotalEnd:null,
			fightNumber:"",
			paxMin: null,
			paxMax: null
		};
		return {
			modelId: -1,
			showSingleModal: false,
			showSelectAll: true,
			sortBy: "reservationId",
			sortDesc: true,
			filters: { ...defaultFilters },
			defaultFilters: { ...defaultFilters },
			formTypeWork: "viewForm", //viewForm -newForm- newFormCopy - newFormLocationReferences
			modelColumns: [
				{
					key: "reservationId",
					label: "Num. Servicio",
					tdClass: "one-line-fix"
				},
				{ key: "supplierName", label: "Proveedor" },
				{ key: "clientName", label: "Cliente" },
				{ key: "pickup", label: "Pickup" },
				{ key: "dropoff", label: "Dropoff" },
				{ key: "trip", label: "Viaje" },
				{
					key: "pickupDatetime",
					label: "Fecha y hora de pickup",
					sortable: true,
					tdClass: "one-line-fix"
				},
				{ key: "flightDatetime", label: "Vuelo"},
				{ key: "serviceType", label: "Tipo de servicio" },
				{ key: "userDriver", label: "Conductor" },
				{ key: "transportUnit", label: "Unidad" },
				{ key: "salesChannel", label: "Canal de venta" },
				{ key: "status", label: "Estado" },
				{ key: "actions", label: "Acciones" }
			],
			pusherInstance: null,
			pusherListening: {
				channel: "private-live-operation-admin",
				event: "status-changed"
			},
			panels:{
				drivers:{assigned:{value:0,percent:0},notAssigned:{value:0,percent:0}},
				driverAppUse:{finished:{value:0,percent:0},notFinished:{value:0,percent:0}},
				trackingStatus:{}
			},
			loadingPanels:false,
			tabActive:null
		};
	},
	computed: {
		salesChannelsOpts(){
			return [{group:'SELECT ALL',options: this.$root.auxVars.salesChannelsOpts}]
		},
		statusOpts() {
			return [
				{
					group: "SELECT ALL",
					options: this.$root.auxVars.transportServiceStatusOpts
				}
			];
		},
		filtersClean() {
			return {
				id: this.filters.id,
				clientFullName: this.filters.clientFullName,
				clientPhone: this.filters.clientPhone,
				destination: this.filters.destination.map(aux => aux.value),
				salesChannel: this.filters.salesChannel.map(aux => aux.value),
				supplier: this.filters.supplier.map(aux => aux.value),
				airport: this.filters.airport.map(aux => aux.value),
				serviceType: this.filters.serviceType.map(aux => aux.value),
				serviceTypeCategory: this.filters.serviceTypeCategory.map(aux => aux.value),
				pickupStartDate: this.filters.pickupStartDate,
				pickupStartTime: this.filters.pickupStartTime,
				pickupEndDate: this.filters.pickupEndDate,
				pickupEndTime: this.filters.pickupEndTime,
				creationStartDate: this.filters.creationStartDate,
				creationEndDate: this.filters.creationEndDate,
				cancelationStartDate: this.filters.cancelationStartDate,
				cancelationEndDate: this.filters.cancelationEndDate,
				asignationStartDate: this.filters.asignationStartDate,
				asignationEndDate: this.filters.asignationEndDate,
				trip: this.filters.trip,
				contactStatus: this.filters.contactStatus,
				revisedStatus: this.filters.revisedStatus,
				status: this.filters.status.map(aux => aux.value),
				statusCheckin: this.filters.statusCheckin.map(aux => aux.value),
				salesChannelReference: this.filters.salesChannelReference,
				supplierReference: this.filters.supplierReference,
				containsEmail: this.filters.containsEmail,
				clientEdited: this.filters.clientEdited,
				clientConfirmed: this.filters.clientConfirmed,
				pickupDatetimeConfirmed: this.filters.pickupDatetimeConfirmed,
				fromPointOfSale: this.filters.fromPointOfSale,
				supplierConfirmation: this.filters.supplierConfirmation,
				placesWithoutCoordinates: this.filters.placesWithoutCoordinates,
				supplierPriceTotalEmpty: this.filters.supplierPriceTotalEmpty,
				onlyWithAdditionalServices: false,
				oneway: this.filters.oneway,
				zones: this.filters.zones,
				invalidSupplierServiceType:  this.filters.invalidSupplierServiceType,
				withSalesChannelPromo: this.filters.withSalesChannelPromo,
				withSupplierPromo: this.filters.withSupplierPromo,
				withChat: this.filters.withChat,
				tags: this.filters.tags,
				netPriceTotalStart: this.filters.netPriceTotalStart,
				netPriceTotalEnd: this.filters.netPriceTotalEnd,
				supplierPriceTotalStart: this.filters.supplierPriceTotalStart,
				supplierPriceTotalEnd: this.filters.supplierPriceTotalEnd,
				fightNumber: this.filters.fightNumber,
				paxMin: this.filters.paxMin,
				paxMax: this.filters.paxMax
			};
		},
		trackingStatus(){
			return this.$root.auxVars.transportServiceTrackingStatusOpts
		}
	},
	methods: {
		filtersCleanTrackingStatus(trackingStatus) {
			let filters = { ...this.filtersClean,
				salesChannel: this.filters.salesChannel.map(({value}) => value),
				status: this.filters.status.map(({value}) => value),
			};
			filters.trackingStatus = trackingStatus;
			return filters;
		},
		updateLists() {
			this.$refs["resumeOperation"].refresh()
			this.getDataPanels()
		},
		updateTotalsByStatus() {
			this.$refs["resumeOperation"].updateTotalsByStatus()
			this.getDataPanels()
		},	
		resView(item) {
			//recuperamos el registro seleccionado de servicios
			this.modelId = item.reservationId;
			//visualizamos el modal de detalle de servicio
			this.showSingleModal = true;
			//configuramos el estado de formulario formService
			this.formTypeWork = "viewForm";
		},
		getLabelTrackingStatus(code) {
			return this.$root.getItemFromAuxVarOpts(
				"transportServiceTrackingStatusOpts",
				code
			);
		},
		getDataPanels(){
			if(this.tabActive!=1) return;
			this.loadingPanels = true;
			this.$root.api
				.get(`live-operation/resume-data`,{params:{filters:this.filtersClean}})
				.then(res => {
					this.panels = res.data;
				})
				.catch(this.$root.handleRequestError)
				.finally(()=>{
					this.loadingPanels = false;
				})
		},
		getDataTrackingStatus(trackingStatusCode,field){
			if (typeof this.panels.trackingStatus[trackingStatusCode] ==='undefined') return 0;//no ha cargado
			try{
				return this.panels.trackingStatus[trackingStatusCode][field];
			}catch(err){
				console.log(err)
			}
			return 0;
		}
	},
	mounted() {
		this.pusherInstance = Pusher.getInstance();
		this.pusherInstance.unsubscribe(this.pusherListening.channel);
		let channel = this.pusherInstance.subscribe(
			this.pusherListening.channel
		);
		channel.bind(this.pusherListening.event, data => {
			this.$root.showAlert(
				"Servicio #" +
					(data.serviceNumber ?? "") +
					" cambió de estado a " +
					(data.trackingStatus ?? "")
			);

			//this.updateLists();
			this.updateTotalsByStatus()
		});

		setTimeout(()=>{
			this.getDataPanels()
		},0)
	},
	destroyed() {
		if (this.pusherInstance !== null) {
			this.pusherInstance.unsubscribe(this.pusherListening.channel);
		}
	},
	watch: {}
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
@media (min-width: 1200px){
	.sidebar-filters{
		width: 70vw !important;
	}
}
.multiselect__tags {
	max-height: 150px;
	overflow-y: auto;
	overflow-y: auto;
}
.active-filter {
	border: 2px solid #021d3e;
}
.snotifyToast__title {
	font-size: 1.5em;
}
.inline-heading {
	display: inline;
}
.inline-button {
	margin-bottom: 10px;
}
.btn-middle {
	margin-right: 8px;
}
</style>
<style scoped>
.floating-tab {
  position: fixed; /* Fix the position */
  top: 10rem; /* Adjust the vertical position */
  right: -8px; /* Adjust the horizontal position */
  z-index: 1000; /* Ensure it appears above other content */
}

.tab-button {
  /*background-color: #8a2be28c;*/
  background-color: blue;
  color: whitesmoke;
  border-radius: 0.25rem; /* Slightly rounded corners */
  padding: 5px 15px; /* Padding around the button */
}

.tab-button:hover {
  background-color: #6a1b9a; 
  transform: translateY(-2px); 
  padding: 5px 20px; 
}

</style>
